import { useQuery } from "@tanstack/react-query";
import { getGoogleReviewsStatus } from "../../api/bReviewsApi";

export const useGetGoogleReviewsStatus = (organisationId, enabled = true) => {
  return useQuery({
    queryKey: ["google-reviews-status", organisationId],
    queryFn: () => getGoogleReviewsStatus(organisationId),
    enabled: !!organisationId && enabled,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: true,
  });
};
